module.exports = __webpack_public_path__ + "resources/d042c4dd0014847032b6ddfc401dda8d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/background-vp-normal.png
// module id = 190
// module chunks = 0